import { getClientId } from 'utils/getClientId'
import { Pet } from 'models/Pet'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'

import { Api } from 'types/Api'

export namespace FetchPets {
  export type Response = Pet[]
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = () => 'pets'

const queryFetcher = (clientId: string) => () => {
  return ApiClient.get<FetchPets.Response>(`/v1/clients/${clientId}/pets`)
}

export const useFetchPets = (options?: FetchPets.Options) => {
  const clientId = getClientId() || ''

  return useQuery<FetchPets.Response, FetchPets.Error>(createKey(), queryFetcher(clientId), options)
}
